const FONT_PRIMARY = "'Public Sans', 'Roboto', 'Helvetica', 'Arial', sans-serif";

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: { fontWeight: 700, fontSize: '2.5rem', lineHeight: 1.25 },
  h2: { fontWeight: 700, fontSize: '2rem', lineHeight: 1.3 },
  h3: { fontWeight: 700, fontSize: '1.5rem', lineHeight: 1.35 },
  h4: { fontWeight: 700, fontSize: '1.25rem', lineHeight: 1.4 },
  h5: { fontWeight: 700, fontSize: '1.125rem', lineHeight: 1.5 },
  h6: { fontWeight: 600, fontSize: '1rem', lineHeight: 1.5 },
  subtitle1: { fontWeight: 600, fontSize: '1rem', lineHeight: 1.5 },
  subtitle2: { fontWeight: 600, fontSize: '0.875rem', lineHeight: 1.57 },
  body1: { fontSize: '1rem', lineHeight: 1.5 },
  body2: { fontSize: '0.875rem', lineHeight: 1.57 },
  caption: { fontSize: '0.75rem', lineHeight: 1.5 },
  overline: { fontSize: '0.75rem', fontWeight: 700, lineHeight: 1.5, textTransform: 'uppercase' },
  button: { fontWeight: 700, textTransform: 'none' },
};

export default typography;
